import React, { forwardRef } from 'react';
import { styled, Switch } from '@mui/material';

const CustomSwitch = styled(Switch)(({ theme }) => {
    return {
        borderRadius: '100px',
        width: '52px',
        height: '28px',
        padding: 0,
        '& > .MuiSwitch-switchBase': {
            left: '4px',
            margin: theme.spacing(1, 0),
            width: '20px',
            height: '20px',
            padding: 0,
            '&.Mui-checked': {
                color: theme.palette.ensightful.shades[0],
                transform: 'translateX(24px)',
            },
        },
        '& > .MuiSwitch-track': {
            background: theme.palette.ensightful.neutral[500],
            opacity: '1 !important',
        },
    };
});

export default forwardRef(({ ...rest }, ref) => {
    return <CustomSwitch ref={ref} inputProps={{ 'aria-label': rest['aria-label'], ...rest.inputProps }} {...rest} />;
});
